import React from 'react';

type InvalidLocationErrorProps = {
  location?: string;
};

function InvalidLocationError({ location }: InvalidLocationErrorProps) {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.icon} aria-hidden="true">
          !
        </div>
        <h1 style={styles.title}>Invalid Location</h1>
        <p style={styles.message}>
          {location ? (
            <>
              No chat widget is available for <strong>{location}</strong>.
            </>
          ) : (
            'No chat widget is available for this location.'
          )}
        </p>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    backgroundColor: '#f8fafc',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  card: {
    maxWidth: '520px',
    width: '100%',
    backgroundColor: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '12px',
    padding: '2rem',
    boxShadow: '0 10px 25px rgba(15, 23, 42, 0.08)',
    textAlign: 'center',
  },
  icon: {
    width: '48px',
    height: '48px',
    margin: '0 auto 1rem',
    borderRadius: '50%',
    backgroundColor: '#fee2e2',
    color: '#b91c1c',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem',
    fontWeight: 700,
  },
  title: {
    margin: '0 0 0.75rem',
    fontSize: '1.5rem',
    color: '#0f172a',
  },
  message: {
    margin: 0,
    color: '#334155',
    fontSize: '0.95rem',
    lineHeight: 1.5,
  },
};

export default InvalidLocationError;
